module.exports = __webpack_public_path__ + "assets/img/homeBg.21040e5f.png";